import { InvoiceProcessingToolPanel } from "../InvoiceProcessingToolPanel";
import { DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutInvoiceProcessingOnHold extends Layout {
    layoutInvoiceProcessingToolPanel: InvoiceProcessingToolPanel;
    panelSecondaryFilters: Panel;
    sourceBillingComments: DataSource;
    sourceInvoiceProcessingCache: DataSource;
    tableProcessing: Table;
}
